import { useState, useEffect } from "react";
import { tokenManager } from "../utils/apiComponent/apiClient";

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Vérifier l'authentification au chargement
    const checkAuth = () => {
      // Essayer de récupérer le token (depuis la mémoire OU depuis le cookie)
      const token = tokenManager.getToken();
      
      if (token) {
        setIsAuthenticated(true);
        // Récupérer les infos utilisateur depuis localStorage
        const userData = localStorage.getItem("userData");
        if (userData) {
          try {
            const parsedUser = JSON.parse(userData);
            setUser(parsedUser);
          } catch (e) {
            console.error("Erreur lors du parsing des données utilisateur:", e);
            setUser(null);
          }
        } else {
          setUser(null);
        }
      } else {
        console.log("No token found");
        setIsAuthenticated(false);
        setUser(null);
      }
      setLoading(false);
    };

    checkAuth();

    // Écouter les changements d'authentification
    const handleAuthChange = (event) => {
      // Vérifier l'authentification à partir du token pour être sûr
      const token = tokenManager.getToken();
      if (token) {
        setIsAuthenticated(true);
        // Utiliser les données de l'événement si disponibles, sinon récupérer depuis localStorage
        if (event.detail?.user) {
          setUser(event.detail.user);
        } else {
          const userData = localStorage.getItem("userData");
          if (userData) {
            try {
              const parsedUser = JSON.parse(userData);
              setUser(parsedUser);
            } catch (e) {
              console.error(
                "Erreur lors du parsing des données utilisateur:",
                e
              );
              setUser(null);
            }
          } else {
            setUser(null);
          }
        }
      } else {
        setIsAuthenticated(false);
        setUser(null);
      }
    };

    window.addEventListener("authChange", handleAuthChange);
    window.addEventListener("auth:changed", handleAuthChange);

    return () => {
      window.removeEventListener("authChange", handleAuthChange);
      window.removeEventListener("auth:changed", handleAuthChange);
    };
  }, []);

  const logout = () => {
    tokenManager.clearTokens();
    localStorage.removeItem("userData");
    setIsAuthenticated(false);
    setUser(null);

    // Rediriger vers la page de connexion
    window.location.href = "/login";
  };

  return {
    isAuthenticated,
    user,
    loading,
    logout,
  };
}
